<template>
  <p>Loading . . .</p>
</template>

<script>

export default {
  data: () => ({
  }),
  mounted () {
    // Establish where to send the user back to if there's a problem; if they're
    // logged in, they go back to their account page; if not, to the login page
    let RETURN_URL = '/login'
    if (this.$auth.check()) {
      RETURN_URL = '/account'
    }

    // We must have a valid OAuth2 type specified
    if (!this.$route.query.type) {
      return this.$router.push(RETURN_URL)
    }
    var clientID = null
    switch (this.$route.query.type) {
      case 'google':
        clientID = process.env.VUE_APP_SYNC_OAUTH2_GOOGLE_CLIENT_ID
        break
      case 'facebook':
        clientID = process.env.VUE_APP_SYNC_OAUTH2_FACEBOOK_CLIENT_ID
        break
    }
    if (clientID === null) {
      return this.$router.push(RETURN_URL)
    }

    // We must have an authentication code from our OAuth2 provider
    if (!this.$route.query.code) {
      return this.$router.push(RETURN_URL)
    }

    this.$auth.oauth2({
      code: true,
      provider: this.$route.query.type,
      params: {
        code: this.$route.query.code,
        client_id: clientID
      },
      success: function (res) {
        // Store the ID token that was in the response body
        this.$auth.token('id', res.data.token)
        if (res.status === 201) {
          this.$router.push('/setup')
        } else {
          this.$router.push('/account')
        }
      },
      error: function (res) {
        // If we have a specific error message, we don't need to know the status
        if (res.response.data && res.response.data.err) {
          this.$auth.flashMessage = res.response.data.err
        } else {
          // Without a specific error, we can show a generic message based on
          // the returned status code.
          switch (res.response.status) {
            case 400:
              this.$auth.flashMessage = 'Please check your input.'
              break
            case 403:
              this.$auth.flashMessage = 'You do not have permission to use the selected account. Please log out and log in with that account directly.'
              break
            case 409:
              this.$auth.flashMessage = 'Another user with your email address already exists. Please log in with that account.'
              break
            default:
              this.$auth.flashMessage = 'An error occurred. Please try again.'
              break
          }
        }

        this.$router.push(RETURN_URL)
      },
      redirect: null
    })
  }
}
</script>
